export default __webpack_public_path__ + "static/media/hourglass.9a71de2c.svg";